import { Divider } from '@advanza/ui'
import FreeLeadTypesList from 'components/freeleadtypes/FreeLeadTypesList'
import Page from 'components/ui/Page'

const FreeLeadTypesPage = () => {
    return (
        <Page title="Free Lead Types">
            <div className="container">
                <Divider />
                <h1>Free Lead Types</h1>
                <p>
                    Manual types are selectable in the provider &quot;Give away free leads&quot;
                    modal. Automated types are set by code and shown here for reference only.
                </p>
                <FreeLeadTypesList />
            </div>
        </Page>
    )
}

export default FreeLeadTypesPage
